"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactToastify = require("react-toastify");

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Toast');

function Toast(_ref) {
  var classesProp = _ref.classes,
      classNameProp = _ref.className,
      overridesProp = _ref.overrides,
      containerId = _ref.containerId,
      closeButton = _ref.closeButton,
      closeButtonClassName = _ref.closeButtonClassName,
      newestOnTop = _ref.newestOnTop,
      position = _ref.position,
      autoClose = _ref.autoClose,
      props = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "overrides", "containerId", "closeButton", "closeButtonClassName", "newestOnTop", "position", "autoClose"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Toast.overrides); // Classes

  var rootClassName = (0, _classnames.default)(classes.root, {}, classNameProp);
  var rootProps = (0, _extends2.default)({}, props, {
    className: rootClassName,
    closeButton: closeButton || false,
    closeButtonClassName: closeButtonClassName || '',
    hideProgressBar: true,
    autoClose: autoClose,
    containerId: containerId || 'hoi-poi-ui',
    newestOnTop: newestOnTop || false,
    position: position
  });
  return /*#__PURE__*/_react.default.createElement(_reactToastify.ToastContainer, (0, _extends2.default)({}, rootProps, {
    enableMultiContainer: true
  }, override['react-toastify']));
}

Toast.overrides = [];
Toast.defaultProps = {
  className: '',
  overrides: {},
  autoClose: 4000
};
process.env.NODE_ENV !== "production" ? Toast.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  containerId: _propTypes.default.any,
  content: _propTypes.default.element,
  closeButton: _propTypes.default.element,
  closeButtonClassName: _propTypes.default.string,
  closeOnClick: _propTypes.default.bool,
  newestOnTop: _propTypes.default.bool,
  position: _propTypes.default.oneOf(['top-right', 'top-left', 'bottom-right', 'bottom-left']),
  autoClose: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.bool])
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Toast);

exports.default = _default;